import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';

//import moment from 'moment';
//import 'moment-duration-format';
import { isDefined, sortReactTable } from '../../../../utils';
import { pageLoaded } from '../../../../utils';
import { columnsAccessors } from '../../../../constants';
import LayeredContent from '../../../../components/v3/LayeredContent';
import TeamEditor from '../../../../components/v3/AdminScreenV3/TeamEditor';
import ZSearch from '../../../../components/Common/ZSearch';
import LoadingControl from '../../../../components/LoadingControl';
import GroupsIcon from '@material-ui/icons/Group';
import { ZRole } from '../../../../generated';

import {
    updateProps,
    loadTeamsScreen,
    createNewTeam,
} from './TeamsScreenActions';

const views = {
    showAllTeams: 'showAllTeams',
    createNewTeam: 'createNewTeam'
}

class TeamsScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            view: views.showAllTeams,
            newTeam: undefined,
            newTeamFormName: undefined,
            newTeamFormType: undefined,
            searchTeamQuery: undefined,
        };

        this.closeCreateNewTeamPopUp = this.closeCreateNewTeamPopUp.bind(this);

        this.onSearchTeam = this.onSearchTeam.bind(this);

        this.getTeamsResultTable = this.getTeamsResultTable.bind(this);
    }

    componentDidMount() {
        pageLoaded('TeamsScreen');
        this.props.dispatch(loadTeamsScreen());
    }

    closeCreateNewTeamPopUp(teamName, selectedManagerId) {
        const newTeam = {
            Name: teamName,
            ParentId: selectedManagerId
        };

        this.props.dispatch(createNewTeam(newTeam));
        this.setState({ showCreateNewUserPopUp: false });
    }

    onSearchTeam({ target }) {
        this.setState({ searchTeamQuery: target.value });
    }

    getTeamsResultTable() {
        const
            {
                teamsSummary,
            } = this.props;

        let result = {};
        const nameColumn = {
            Header: 'Name',
            accessor: 'nameNode',
        };
        //const agentCountColumn = {
        //    Header: 'Number of users',
        //    accessor: 'agentsCount'
        //};
        const supervisoraColumn = {
            Header: 'Supervisor',
            accessor: columnsAccessors.supervisor
        };
        const agentsColumn = {
            Header: 'Agents',
            accessor: columnsAccessors.agents
        };
        const actionColumn = {
            Header: 'action',
            accessor: columnsAccessors.action
        };

        result.columns = [nameColumn, /* agentCountColumn, supervisoraColumn, agentsColumn,*/ actionColumn];

        result.data = (teamsSummary && Array.isArray(teamsSummary)) ? teamsSummary : [];

        //filter by teamName
        if (isDefined(this.state.searchTeamQuery) && this.state.searchTeamQuery !== '') {
            result.data = result.data.filter(a => a.name.toLowerCase().includes(this.state.searchTeamQuery.toLowerCase()));
        }

        //form table body by adding icons and styling
        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                if (isDefined(row.name)) {
                    row.nameNode = (<div className="flex-container-start" style={{ marginLeft: "10px" }}>
                        <div>
                            <GroupsIcon />
                        </div>
                        <div style={{ margin: "0 0 10px 10px" }}>{row.name}</div>
                    </div>)
                }

                if (isDefined(row.isEnabled)) {
                    var statusName = row.isEnabled ? 'Enable' : 'Disable'

                    const avatarStyle = row.isEnabled ? "live-survey-avatar" : "draft-survey-avatar";
                    row.status = (<div className={avatarStyle}>
                        {statusName}
                    </div>);

                }
                row.action = 'View/Edit'
            })
        }

        const loading = !teamsSummary;
        const teamsResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={10}
            loading={loading}
            className="admin-page-users-table -striped -highlight"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row && rowInfo.original) {
                    return {
                        onClick: () => {
                            //onClick(rowInfo.original.id)
                        }
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        return teamsResultTable;
    }

    showCreateNewUserPopUp = () => {
        this.setState({ showCreateNewUserPopUp: true });
    }

    render() {
        const
            {
                currentUser,
                teamsSummary,
                teamsHierarchy,
                domainValues
            } = this.props;
        if (!currentUser) {
            return <LoadingControl />;
        }
        if (currentUser.RoleId !== ZRole.Manager &&
            currentUser.RoleId !== ZRole.Admin &&
            currentUser.RoleId !== ZRole.SuperAdmin) {
            return <LoadingControl />;
        }

        const teamSearch = (<ZSearch placeHolder="Search team name" searchValue={this.state.searchTeamQuery} onChange={this.onSearchTeam} />);
        const teamCount = teamsSummary
            ? (<p className="H2-white" style={{ marginLeft: '10px' }}>({teamsSummary.length} teams)</p>)
            : undefined;

        const createNewUserButton = (
            <div className="v3-button agent-view-interactions" onClick={this.showCreateNewUserPopUp}>
                New Team
            </div>);

        if (this.state.view === views.showAllTeams) {
            var teamsResultTable = this.getTeamsResultTable();

            return (
                <div className="main-page-width">
                    <div className="teams-table-for-manager filters-wrapper" style={{ marginTop: '28px' }}>
                        <div className="teams-table-for-manager filter-area-title-wrapper">
                            <label className="teams-table-for-manager all-teams-title">All Teams {teamCount}</label>
                            {createNewUserButton}
                        </div>
                        <div className="teams-table-for-manager teams-filter-names-wrapper">
                            {teamSearch}
                        </div>
                    </div>
                    <LayeredContent teamsHierarchy={teamsHierarchy} />
                    {/*<div style={{ position: 'relative', zIndex: 0 }}>*/}
                    {/*    {teamsResultTable}*/}
                    {/*</div>*/}
                    {this.state.showCreateNewManagerTeamPopUp &&
                        (<TeamEditor
                            teamLevel={1}
                            onClose={this.closeCreateNewTeamPopUp} />)}
                    {this.state.showCreateNewUserPopUp &&
                        (<TeamEditor
                            domainValues={domainValues}
                            teamLevel={2}
                            onClose={this.closeCreateNewTeamPopUp} />)}
                </div>);
        }
        else {
            return (
                <div className="main-page-width">
                    <div className="flex-container" style={{ margin: '25px 0' }}>
                        {leftBar}
                        <label> Create New Team: {this.state.newTeam.Name} - {this.state.newTeam.Type}</label>
                    </div>

                </div>);
        }
    }
}

const select = state => ({ ...state.TeamsScreen, ...state.session });

export default connect(select)(TeamsScreen);